// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderCard_container__30Hak","contentContainer":"OrderCard_contentContainer__h5sD0","title":"OrderCard_title__1Pylk"};